'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useCallback, useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
const defaultBreakpointCols = {
    1400: 3,
    1200: 2,
    992: 2,
    768: 1,
    576: 1,
};
const reCalculateColumnCount = (breakpointColsObject, initialColumns) => {
    const windowWidth = (window && window.innerWidth) || Infinity;
    let matchedBreakpoint = Infinity;
    let columns = initialColumns;
    for (const breakpoint in breakpointColsObject) {
        const optBreakpoint = Number.parseInt(breakpoint);
        const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;
        if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
            matchedBreakpoint = optBreakpoint;
            columns = breakpointColsObject[breakpoint];
        }
    }
    columns = Math.max(1, columns || 1);
    return columns;
};
const Masonry = ({ children, breakpointCols = defaultBreakpointCols, gap = 'normal', initialColumns = 3, }) => {
    const [columnCount, setColumnCount] = useState(initialColumns);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setColumnCount(reCalculateColumnCount(breakpointCols, initialColumns));
        const listener = () => {
            setColumnCount(reCalculateColumnCount(breakpointCols, initialColumns));
        };
        window.addEventListener('resize', listener);
        return () => window.removeEventListener('resize', listener);
    }, [setColumnCount, breakpointCols, initialColumns]);
    const itemsInColumns = useCallback(() => {
        const currentColumnCount = columnCount;
        const itemsInColumns = new Array(currentColumnCount);
        const items = Children.toArray(children);
        for (let i = 0; i < items.length; i++) {
            const columnIndex = i % currentColumnCount;
            if (!itemsInColumns[columnIndex]) {
                itemsInColumns[columnIndex] = [];
            }
            itemsInColumns[columnIndex].push(items[i]);
        }
        return itemsInColumns;
    }, [children, columnCount]);
    const renderColumns = useMemo(() => {
        const childrenInColumns = itemsInColumns();
        const columnWidth = `${100 / childrenInColumns.length}%`;
        return childrenInColumns.map((items, i) => {
            return (_jsx("div", { style: { width: columnWidth }, children: items }, i));
        });
    }, [itemsInColumns]);
    const className = classnames({
        flex: true,
        'w-auto': true,
        'gap-2': gap === 'small',
        'gap-3': gap === 'normal',
    });
    return _jsx("div", { className: className, children: renderColumns });
};
export default Masonry;
//# sourceMappingURL=index.js.map